var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandRock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 96C390.852 96 382.385 98.697 375.107 103.143C370.941 80.869 351.467 64 328 64C311.287 64 296.598 72.568 288 85.531V80C288 53.484 266.5 32 240 32C227.5 32 216.213 36.896 207.67 44.73C205.959 19.77 185.381 0 160 0C133.5 0 112 21.484 112 48V176C112 184.836 104.836 192 96 192S80 184.836 80 176V130.516L50 154.516C38.625 163.625 32 177.422 32 192V261.205C32 294.33 48 325.768 74.812 345.33L128 384V512H384V384C422.551 358.135 448 314.191 448 264.377V144C448 117.484 426.5 96 400 96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandRock);
export default __webpack_public_path__ + "static/media/hand-rock.67808f4e12732986877a085fb4c8d6b6.svg";
export { ForwardRef as ReactComponent };